import type { ChatMessageProps } from "@albertine/design-system/components/chat";

export function replyImageUrl(message: ChatMessageProps): string | undefined {
    const imageAttachment = message.attachments?.find(
        (attachment) =>
            attachment.mimeType.startsWith("image/") && attachment.url !== undefined,
    );
    if (imageAttachment?.url) {
        return imageAttachment.url;
    }

    return message.articles?.[0]?.imageUrl ?? message.confirmedBookings?.[0]?.imageUrl;
}
